import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LandinPage } from '../../auth/models/IUser';
import { AuthService } from '../../auth/services/auth.service';
import { StorageService } from '../helpers/storage.service';
import { Storagekeys } from '../model/storage';

function getDefaultLandingUrl(storage: StorageService): string {
  const reDirectTo = storage.getItem(Storagekeys.redirectTo, true);
  if (reDirectTo === LandinPage.HOST_PAGE) {
    return '/host/organizations';
  } else if (reDirectTo === LandinPage.VERIFY_PAGE) {
    return '/host/verify-user';
  } else if (
    reDirectTo === LandinPage.AGENT_PAGE ||
    reDirectTo === LandinPage.TENANT_DASHBOARD ||
    reDirectTo === LandinPage.ADMIN_DASHBOARD
  ) {
    if (reDirectTo === LandinPage.AGENT_PAGE) {
      return '/agent';
    } else if (
      reDirectTo === LandinPage.TENANT_DASHBOARD ||
      reDirectTo === LandinPage.ADMIN_DASHBOARD
    ) {
      return '/tenant/dashboard';
    } else {
      return '/tenant';
    }
  } else {
    return '/tenant/profile-settings';
  }
}

export const entryRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const storage = inject(StorageService);
  const permissions = authService.getPermissions();
  const forceLogout = route.queryParamMap.get('forceLogout');

  if (forceLogout === 'true' || !authService.isAuthenticatedUser()) {
    return true;
  }
  return router.parseUrl(getDefaultLandingUrl(storage));
};
